const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

function buildHeaders(extra = {}) {
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    "Content-Type": "application/json",
    ...extra,
  };
}

async function parseError(response) {
  try {
    const data = await response.json();
    return data?.message || data?.hint || data?.details || "Request failed.";
  } catch {
    return "Request failed.";
  }
}

export async function verifyAdminPasscode(passcode) {
  if (!isSupabaseConfigured || !passcode?.trim()) return false;

  const response = await fetch(`${SUPABASE_URL}/rest/v1/rpc/verify_admin_passcode`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify({ input_passcode: passcode.trim() }),
  });
  if (!response.ok) return false;
  const result = await response.json();
  return result === true;
}

export async function createLead(lead) {
  if (!isSupabaseConfigured) {
    throw new Error("Supabase is not configured.");
  }
  const response = await fetch(`${SUPABASE_URL}/rest/v1/leads`, {
    method: "POST",
    headers: buildHeaders({ Prefer: "return=representation" }),
    body: JSON.stringify([lead]),
  });
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
  const data = await response.json();
  return Array.isArray(data) ? data[0] : data;
}

export async function fetchLeads() {
  if (!isSupabaseConfigured) {
    throw new Error("Supabase is not configured.");
  }
  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/leads?select=*&order=created_at.desc`,
    {
      headers: buildHeaders(),
    }
  );
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
  return response.json();
}

export async function deleteLeadById(id) {
  if (!isSupabaseConfigured) {
    throw new Error("Supabase is not configured.");
  }
  const response = await fetch(
    `${SUPABASE_URL}/rest/v1/leads?id=eq.${encodeURIComponent(id)}`,
    {
      method: "DELETE",
      headers: buildHeaders({ Prefer: "return=minimal" }),
    }
  );
  if (!response.ok) {
    throw new Error(await parseError(response));
  }
}
